import { createFileRoute, DefaultGlobalNotFound } from '@tanstack/react-router';

export const Route = createFileRoute('/www/$')({
	component: RouteComponent,
});

function RouteComponent() {
	return <DefaultGlobalNotFound />;
}
